module.exports = __webpack_public_path__ + "static/media/cctvIcon_hover.0823ba09.svg";